import { css } from '@emotion/react'
import { Text, VFlow } from 'bold-ui'

import { AtividadeColetivaGrupoItemModel } from './model-atividadeColetivaGrupoSelectField'

export type AtividadeColetivaGrupoSelectFieldItemProps = {
  item: AtividadeColetivaGrupoItemModel
}

export function AtividadeColetivaGrupoSelectFieldItem(props: Readonly<AtividadeColetivaGrupoSelectFieldItemProps>) {
  const { item } = props

  return (
    <VFlow style={styles.item} vSpacing={0}>
      <Text fontWeight='bold'>{item.nome}</Text>
      <Text>{item.equipesEnvolvidas}</Text>
      <Text>{item.unidadeDeSaude}</Text>
    </VFlow>
  )
}

const styles = {
  item: css`
    padding: 0 0.3rem;
  `,
}
